import axios from 'axios';
import parse from 'date-fns/parse';
import format from 'date-fns/format';

axios.defaults.xsrfHeaderName = "X-CSRFToken";
axios.defaults.xsrfCookieName = "csrftoken";

export default class PublicBookingService {
    constructor() {
        this.apiPath = '/booking/api/book';
    }

    getClientObject(bookingData) {
        return { 
            ...bookingData
        };
    }   

    getApiObject(customer, trips) {
        let apiObject = {
            id: null,
            booking_code: null,
            first_name: customer.first_name,
            last_name: customer.last_name,
            telephone: customer.telephone,
            email: customer.email,
            trips: trips.map(trip => ({
                id: null,
                booking_day: {
                    id: null,
                    date: trip.booking_day.date ? format(trip.booking_day.date, 'yyyy-MM-dd') : null
                },
                route: trip.route,
                start_location: trip.start_location ? trip.start_location : '',
                end_location: trip.end_location ? trip.end_location : '',
                adults: trip.passengers.adults,
                children_under16: trip.passengers.children_under16,
                children_under1: trip.passengers.children_under1,
                dogs: trip.passengers.dogs,
                bikes: trip.passengers.bikes
            }))
        };
        
        return apiObject;
    }

    getStops() {
        return axios
            .get(`${this.apiPath}/get_stops/`)
            .then(res => res.data);
    }

    getOptions(startName, endName, passengers) {
        return axios
            .post(`${this.apiPath}/get_options/`, {
                'start_name': startName,
                'end_name': endName,
                'passengers': passengers
            })
            .then(res => res.data.map(
                option => ({
                    ...option,
                    date: parse(option.date, 'yyyy-MM-dd', new Date())
                })
            ));
    }

    checkBooking(customer, trips) {
        return axios
            .post(`${this.apiPath}/check_booking/`, this.getApiObject(customer, trips))
            .then(res => res.data);
    }

    
    makeBooking(customer, trips) {
        return axios
            .post(`${this.apiPath}/`, this.getApiObject(customer, trips))
            .then(res => res.data);
    }

    getEditOptions(bookingUuid, trip) {
        return axios
            .post(`${this.apiPath}/get_edit_options/`, {
                'start_name': trip.location.start,
                'end_name': trip.location.end,
                'passengers': trip.passengers.total,
                'booking_uuid': bookingUuid,
            })
            .then(res => res.data.map(
                option => ({
                    ...option,
                    date: parse(option.date, 'yyyy-MM-dd', new Date())
                })
            ));
    }

    checkEditBooking(bookingUuid, trips) {
        return axios
            .post(`${this.apiPath}/check_edit_booking/`, {
                'booking_uuid': bookingUuid,
                'trips': trips.map(trip => ({
                    id: trip.id,
                    booking_day: {
                        id: null,
                        date: trip.bookingDay.date ? format(trip.bookingDay.date, 'yyyy-MM-dd') : null
                    },
                    route: trip.route
                }))
            })
            .then(res => res.data);
    }

    editBooking(bookingUuid, trips) {
        return axios
            .post(`${this.apiPath}/edit_booking/`, {
                'booking_uuid': bookingUuid,
                'trips': trips.map(trip => ({
                    id: trip.id,
                    booking_day: {
                        id: null,
                        date: trip.bookingDay.date ? format(trip.bookingDay.date, 'yyyy-MM-dd') : null
                    },
                    route: trip.route
                }))
            })
            .then(res => res.data);
    }
}